<div class="phone-row">
  <mat-form-field class="country-code-field" appearance="outline">
    <mat-label>{{ 'SHARED.PHONE_INPUT.CODE' | translate }}</mat-label>
    <mat-select
      #countrySelect
      [formControl]="countryControl"
      [panelWidth]="280"
      (openedChange)="onCountryPanelToggled($event)"
    >
      <mat-select-trigger>
        <span class="flag">{{ selectedCountry?.flag }}</span> +{{ selectedCountry?.callingCode }}
      </mat-select-trigger>
      <mat-option>
        <ngx-mat-select-search
          [formControl]="countrySearchControl"
          [placeholderLabel]="'SHARED.PHONE_INPUT.SEARCH_COUNTRY_PLACEHOLDER' | translate"
          [noEntriesFoundLabel]="'SHARED.PHONE_INPUT.NO_COUNTRIES_FOUND' | translate"
        ></ngx-mat-select-search>
      </mat-option>
      @for (country of filteredCountries; track country.code) {
      <mat-option [value]="country.code">
        {{ country.flag }} {{ country.name }} (+{{ country.callingCode }})
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="phone-number-field" appearance="outline">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      matInput
      type="tel"
      [formControl]="internalControl"
      [errorStateMatcher]="errorMatcher"
      (blur)="onBlur()"
    />
    <mat-error>
      @if (internalControl?.hasError('required')) {
        {{ 'VALIDATION.REQUIRED' | translate }}
      } @else if (internalControl?.hasError('invalidPhone')) {
        {{ 'SHARED.PHONE_INPUT.INVALID_PHONE_NUMBER' | translate }}
      }
    </mat-error>
  </mat-form-field>
</div>
